import { createSelector } from '@ngrx/store';
import { IProfessionalState } from './professional.reducer';
const professionalStore = (state: any) =>
  state.professional as IProfessionalState;
export const selectProfessionalLista = createSelector(
  professionalStore,
  (state) => state.lista
);

export const selectProfessionalCurrentID = createSelector(
  professionalStore,
  (state) => state.currentProfessionalId
);

export const selectProfessionalLoadCreate = createSelector(
  professionalStore,
  (state) => state.isLoadingCreate
);

export const selectProfessionalLoad = createSelector(
  professionalStore,
  (state) => state.isLoading
);

export const selectProfessional = createSelector(
  professionalStore,
  (state) => state
);

export const selectMessageTypeProfessional = createSelector(
  professionalStore,
  (state) => state.type
);

export const selectCurrentProfessional = createSelector(
  professionalStore,
  (state) => state.currentProfessional
);

export const selectActivatedProfessional = createSelector(
  professionalStore,
  (state) => { return state.lista.filter( p => p.isActive )}
);

export const selectProfessionalState = createSelector(
  professionalStore,
  (state) => {return { type: state.type, action: state.action}}
);

export const selectPostProfessionalError = createSelector(
  professionalStore,
  (state) => state.error
)